<p-dialog
  [closable]="false"
  [(visible)]="displayModal"
  [modal]="true"
  [style]="{ width: '75vw' }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body">
  <ng-template pTemplate="header">
    <div class="w-100 has-border">
      <h2>Copy Header</h2>
    </div>
  </ng-template>
  <div class="dialog-section mb-4">
    <h3>Copy Header or quotes</h3>
    <p-table
      #dt
      [value]="salesOrderHeader"
      [(selection)]="selectedSalesOrderHeader"
      styleClass="p-datatable-customers ordersLineItems no-wrap"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="true"
      dataKey="salesOrderIdD365">
      <ng-template pTemplate="header">
        <tr>
          <th class="col-center" style="width: 3rem">
            <!-- <p-tableHeaderCheckbox></p-tableHeaderCheckbox> -->
          </th>
          <th class="number">Number</th>
          <th class="status">Status</th>
          <th class="name">Client Name</th>
          <th class="jname">Job Name</th>
          <th class="buyer">Buyer</th>
          <th class="cust-po">Cust PO #</th>
          <th class="bconsultant">Branding Consultant</th>
          <th class="date-time">Created Date & Time</th>
          <th class="subtotal">Order Subtotal</th>
          <th class="commission">Commission</th>
          <th class="gp">Gp%</th>
          <th class="currency">Currency</th>
          <th class="inhanddate">In Hands</th>
        </tr>
        <tr>
          <th></th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="salesOrderIdD365"
                id="salesOrderIdD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'salesOrderIdD365',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th></th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="customerName"
                id="customerName"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'customerName',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="jobNameD365"
                id="jobNameD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'jobNameD365',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th></th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="customerPONumberD365"
                id="customerPONumberD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'customerPONumberD365',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="brandingConsultant"
                id="brandingConsultant"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'brandingConsultant',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-salesOrderHeader
        let-rowIndex="rowIndex">
        <tr class="p-selectable-row">
          <td class="col-center">
            <p-tableRadioButton
              #e
              [value]="salesOrderHeader"
              (click)="
                selectRow(e.checked, salesOrderHeader.salesOrderIdD365)
              "></p-tableRadioButton>
          </td>
          <td class="number">
            {{ salesOrderHeader.salesOrderIdD365 }}
          </td>
          <td class="status">
            {{ salesOrderHeader.salesOrderStatusD365 }}
          </td>
          <td class="name">
            {{ salesOrderHeader.customerName }}
          </td>
          <td class="jname">
            {{ salesOrderHeader.jobNameD365 }}
          </td>
          <td class="buyer">
            {{ salesOrderHeader.buyerD365 }}
          </td>
          <td class="cust-po">
            {{ salesOrderHeader.customerPONumberD365 }}
          </td>
          <td class="bconsultant">
            {{ salesOrderHeader.brandingConsultant }}
          </td>
          <td class="date-time">
            <span *ngIf="salesOrderHeader?.createdDate | hidedynamicsdate">
              {{ salesOrderHeader.createdDate | date: "MM-dd-yyyy" }}
            </span>
          </td>
          <td class="subtotal">
            {{ salesOrderHeader.orderSubTotal | number: "1.2-2" }}
          </td>
          <td class="commission">
            {{ salesOrderHeader.commissionD365 | number: "1.2-2" }}
          </td>
          <td class="gp">
            <span *ngIf="salesOrderHeader.grossProfitPercentageD365 !== 'NaN'">
              {{ salesOrderHeader.grossProfitPercentageD365 | number: "1.2-2" }}
            </span>
            <span *ngIf="salesOrderHeader.grossProfitPercentageD365 === 'NaN'">
              {{ 0 | number: "1.2-2" }}
            </span>
          </td>
          <td class="currency">
            {{ salesOrderHeader.currency }}
          </td>
          <td class="inhanddate">
            {{ salesOrderHeader.inhandate | date: "MM-dd-yyyy" }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No sale order header found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="dialog-section mb-4">
    <h3>Line items</h3>
    <p-table
      #dt
      [value]="salesOrderLine"
      [(selection)]="selectedSalesOrderLine"
      selectionMode="multiple"
      styleClass="p-datatable-customers ordersLineItems no-wrap"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="true"
      [filterDelay]="0"
      [rowHover]="true"
      dataKey="id">
      <ng-template pTemplate="header">
        <tr>
          <th class="col-center" style="width: 3rem" (click)="onLineSelect()">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>

          <th class="number">#</th>
          <th class="notes">Notes</th>
          <th class="attachment">
            <i class="pi pi-paperclip icon-blue mx-1"></i>
          </th>
          <th class="vendor-sku">Vendor Sku</th>
          <th class="vendor-sku">Category</th>
          <th class="description">Description</th>
          <th class="unmatched">Unmatched</th>
          <th class="quantity">Quantity</th>
          <th class="sell">Sell</th>
          <th class="sell-total">Sell Total</th>
          <th class="net">Net</th>
          <th class="status">Status</th>
          <th style="width: 100px" class="vendor-name">Vendor Name</th>
          <th class="vendor-name">Po Number</th>
          <th class="vendor-name">Project</th>
        </tr>
        <tr>
          <th></th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="lineNumberD365"
                id="lineNumberD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'lineNumberD365',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th></th>
          <th></th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="externalItemNumberD365"
                id="externalItemNumberD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'externalItemNumberD365',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="itemNumberD365"
                id="itemNumberD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'itemNumberD365',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="lineDescriptionD365"
                id="lineDescriptionD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'lineDescriptionD365',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="orderedPurchaseQuantityD365"
                id="orderedPurchaseQuantityD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'orderedPurchaseQuantityD365',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="vendorNameD365"
                id="vendorNameD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'vendorNameD365',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="purchaseOrderD365"
                id="purchaseOrderD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'purchaseOrderD365',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="projectIdD365"
                id="projectIdD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'projectIdD365',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-salesOrderLine let-rowIndex="rowIndex">
        <ng-container>
          <tr class="p-selectable-row" (click)="onLineSelect()">
            <td class="col-center">
              <p-tableCheckbox [value]="salesOrderLine"></p-tableCheckbox>
            </td>
            <td class="number">
              <span class="link">{{ salesOrderLine.lineNumberD365 }}</span>
            </td>
            <td class="notes">
              <span class="me-1">{{ salesOrderLine.notes }}</span>
              <i class="icon-Notes icon"></i>
            </td>
            <td class="attachment">
              <span class="me-1">{{ salesOrderLine.attachement }}</span>
              <i class="pi pi-paperclip icon-blue mx-1"></i>
            </td>
            <td class="vendor-sku">
              {{ salesOrderLine.externalItemNumberD365 }}
            </td>
            <td>
              {{ salesOrderLine.itemNumberD365 }}
            </td>
            <td class="description">
              {{ salesOrderLine.lineDescriptionD365 }}
            </td>
            <td class="unmatched">
              {{ salesOrderLine.orderedPurchaseQuantityD365 }}
            </td>
            <td class="quantity">
              {{ salesOrderLine.orderedPurchaseQuantityD365 }}
            </td>
            <td class="sell">
              {{ salesOrderLine.sellD365 }}
            </td>
            <td class="sell-total">
              {{ salesOrderLine.sellTotalD365 | number }}
            </td>
            <td class="net">
              {{ salesOrderLine.purchasePriceD365 }}
            </td>
            <td class="status">
              {{ salesOrderLine.lineStatusD365 }}
            </td>
            <td class="vendor-name" style="width: 100px">
              {{ salesOrderLine.vendorNameD365 }}
            </td>
            <td>
              {{ salesOrderLine.purchaseOrderD365 }}
            </td>
            <td>
              {{ salesOrderLine.projectIdD365 }}
            </td>
          </tr>
        </ng-container>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No line item found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="dialog-section">
    <h3>Quotations</h3>
    <p-accordion>
      <p-accordionTab header="Sale order {{ saleOrderId }}" [selected]="false">
        <ul>
          <li *ngFor="let item of SOLinesItem">Line item {{ item }}</li>
        </ul>
      </p-accordionTab>
      <p-accordionTab header="Quotation {{ saleOrderId }}">
        <ul>
          <li *ngFor="let item of QuotesLinesItem">Line item {{ item }}</li>
        </ul>
      </p-accordionTab>
    </p-accordion>
  </div>
  <ng-template class="pt-3" pTemplate="footer">
    <button class="btn btn-secondary" (click)="closeDialog()">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="save()"
      [disabled]="!selectedSalesOrderHeader">
      Save
    </button>
  </ng-template>
</p-dialog>
